import { cn } from "@repo/ui";

/**
 * Default GlassPanel shell (frosted). Aligns with marketing hero glass: white frost in light,
 * solid `--marketing-surface` in dark — see `MARKETING_LANDING_GLASS_PANEL_CLASS` /
 * `MARKETING_LANDING_HERO_GLASS_INNER_CLASS` in `marketing-layout-vars.ts`.
 */
export const GLASS_PANEL_SHELL_FRAME_CLASSNAME =
	"relative overflow-hidden border shadow-sm backdrop-blur-xl border-6";

/** Opaque panels: no backdrop blur (onboarding subtext, etc.). */
export const GLASS_PANEL_SHELL_FRAME_OPAQUE_CLASSNAME =
	"relative overflow-hidden border shadow-sm border-6";

export const GLASS_PANEL_SURFACE_LIGHT_TRANSLUCENT_CLASSNAME =
	"border-black/8 bg-white/70";

export const GLASS_PANEL_SURFACE_DARK_TRANSLUCENT_CLASSNAME =
	"border-white/25 bg-[color:var(--marketing-surface)]";

export const GLASS_PANEL_SURFACE_LIGHT_OPAQUE_CLASSNAME =
	"border-black/10 bg-white";

export const GLASS_PANEL_SURFACE_DARK_OPAQUE_CLASSNAME =
	"border-white/25 bg-[color:var(--marketing-surface)]";

/** System tone: both fills in the DOM; `html.dark` selects the dark surface (no theme hook flash). */
export const GLASS_PANEL_SURFACE_SYSTEM_TRANSLUCENT_CLASSNAME = cn(
	GLASS_PANEL_SURFACE_LIGHT_TRANSLUCENT_CLASSNAME,
	"dark:border-white/25 dark:bg-[color:var(--marketing-surface)]",
);

export const GLASS_PANEL_SURFACE_SYSTEM_OPAQUE_CLASSNAME = cn(
	GLASS_PANEL_SURFACE_LIGHT_OPAQUE_CLASSNAME,
	"dark:border-white/25 dark:bg-[color:var(--marketing-surface)]",
);

/**
 * Kanban column / static dual-tone hosts: light frosted + dark solid surface in one class list.
 */
export const GLASS_PANEL_COLUMN_SHELL_CLASSNAME = cn(
	GLASS_PANEL_SHELL_FRAME_CLASSNAME,
	GLASS_PANEL_SURFACE_SYSTEM_TRANSLUCENT_CLASSNAME,
);

export function glassPanelSurfaceFillForTone(
	tone: "light" | "dark" | "system",
	surfaceVariant: "translucent" | "opaque",
): string {
	if (tone === "system") {
		return surfaceVariant === "opaque"
			? GLASS_PANEL_SURFACE_SYSTEM_OPAQUE_CLASSNAME
			: GLASS_PANEL_SURFACE_SYSTEM_TRANSLUCENT_CLASSNAME;
	}
	if (surfaceVariant === "opaque") {
		return tone === "light"
			? GLASS_PANEL_SURFACE_LIGHT_OPAQUE_CLASSNAME
			: GLASS_PANEL_SURFACE_DARK_OPAQUE_CLASSNAME;
	}
	return tone === "light"
		? GLASS_PANEL_SURFACE_LIGHT_TRANSLUCENT_CLASSNAME
		: GLASS_PANEL_SURFACE_DARK_TRANSLUCENT_CLASSNAME;
}
